import {atom} from 'jotai'
// import { atomWithStorage } from 'jotai/utils';

import {MemberDetail, MemberTab} from '../domain'

export const memberDetailAtom = atom<MemberDetail | null>(null)
export const memberDetailTabAtom = atom<MemberTab | null>(null)

// export const tabNameAtom = atomWithStorage<'Overview' | 'Segment' | 'Address' | 'Consent' | 'Transaction' | 'Engagement' | 'SmsEngagement' | 'PushEngagement' | 'EmailEngagement'>("MemberTab", "Overview");
export const tabNameAtom = atom<
  | 'Overview'
  | 'Segment'
  | 'Address'
  | 'Consent'
  | 'Transaction'
  | 'Engagement'
  | 'SmsEngagement'
  | 'PushEngagement'
  | 'EmailEngagement'
>('Overview')
